<template>
  <router-view />
</template>

<script>

export default {
    name: "TeacherCourses",
}
</script>

<style lang="scss" scoped>
</style>